import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../../../../../util/utils';
import {useEngagementId} from '../../../../../../../../../util/customHooks';
import {getitControlById} from '../../../../../../../../../selectors/ISA315/selectors';
import {deleteITControl} from '../../../../../../../../../actions/ITControl/itcontrolaction';
import LoadingIndicator from '../../../../../../../LoadingIndicator/LoadingIndicator';
import BodySpecialAccordionContentListItem from '../../../StyledBodySpecialAccordionContentListItem';
import ProgressBar from '../../../../../../../BaseComponentWrappers/MotifProgressBar';
import {clientSideEventNames} from '../../../../../../../../../util/uiconstants';

function ViewItControlListItem({itControlId, bodyId, isUnrelatedItControl}) {
	const engagementId = useEngagementId();
	const itControl = useSelector((state) => getitControlById(state, itControlId));

	const [isLoading, setIsLoading] = useState(false);
	const [isDeleteValue, setIsDeleteValue] = useState(false);

	const dispatch = useDispatch();

	async function handleDeleteItControl() {
		setIsDeleteValue(true);
		try {
			dispatch(deleteITControl(engagementId, itControlId, bodyId, isUnrelatedItControl));
		} finally {
			setIsDeleteValue(false);
			window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
		}
	}

	return (
		<React.Fragment>
			{isLoading ? (
				<StyledItControlLoadingIndicatorContainer>
					<LoadingIndicator show={isLoading} />
				</StyledItControlLoadingIndicatorContainer>
			) : (
				<StyledViewItControlListItem
					remove
					removeLabel={labels.delete}
					className={`view-itcontrol-list-item ${isDeleteValue ? 'greyOutAreaContainer' : ''}`}
					onRemoveClick={handleDeleteItControl}
				>
					{isDeleteValue && (
						<ProgressBar className={'greyOutArea'} labelComponent={<span>{labels.deletingLabel}</span>} />
					)}
					<section className="view-it-control-list-item-content">{itControl?.itControlName}</section>
				</StyledViewItControlListItem>
			)}
		</React.Fragment>
	);
}

const StyledViewItControlListItem = styled(BodySpecialAccordionContentListItem)`
	width: calc(100% - var(--px-20));
	position: relative;
	.greyOutAreaOverLay {
		background-color: var(--neutrals-25);
		opacity: 0.7;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
	}
	.motif-progress-bar-wrapper {
		top: 0;
	}
	&:last-child {
		border-bottom: none;
	}
	.view-it-control-list-item-content {
		width: calc(100% - var(--px-50));
		font-weight: 300;
		font-size: var(--px-12);
		color: var(--neutrals-900);
		line-height: normal;
		&:hover {
			font-weight: bold;
		}
	}
	a {
		line-height: normal;
		&:hover {
			text-decoration: underline;
		}
	}
	&.greyOutAreaContainer {
		.view-it-control-list-item-content {
			color: transparent;
			text-shadow: 0 0 var(--px-5) rgba(0, 0, 0, 0.5);
		}
	}
`;

const StyledItControlLoadingIndicatorContainer = styled.section`
	width: calc(100% - var(--px-20));
`;

export default ViewItControlListItem;
